import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=f58cb63e&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=f58cb63e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58cb63e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f58cb63e')) {
      api.createRecord('f58cb63e', component.options)
    } else {
      api.reload('f58cb63e', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=f58cb63e&scoped=true&", function () {
      api.rerender('f58cb63e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2sU485883QTbl/JS/comp/PopupBox.vue"
export default component.exports